import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ProgressSpinner } from "primereact/progressspinner";
import { getNewStations } from "../../../../services/clearing/stations";
import { getAllCustomers } from "../../../../services/clearing/customers";
import { AssignStationListItem } from "../UnassignedStationsButton/components/AssignStationListItem";
import CollapsibleSection from "../../../../components/CollapsibleSection";
import SectionStatusBadge from "../SectionStatusBadge";

const columnStyle = { color: "black" };

export const UnassignedStationsSection = () => {
  const [stations, setStations] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [stationsResult, customersResult] = await Promise.all([
          getNewStations(),
          getAllCustomers(),
        ]);

        if (stationsResult === false) {
          setError(true);
        } else if (Array.isArray(stationsResult)) {
          setStations(stationsResult);
        }

        if (Array.isArray(customersResult)) {
          setCustomers(customersResult);
        }
      } catch {
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const customerOptions =
    customers?.map((customer) => ({
      name: customer?.["account_holder_name"],
      code: customer?.id,
    })) || [];

  const stationData = stations.map((id, index) => ({ id, index }));

  const assignBodyTemplate = (rowData) => (
    <AssignStationListItem
      stationId={rowData.id}
      customerOptions={customerOptions}
    />
  );

  return (
    <CollapsibleSection
      title="Unassigned Stations"
      storageKey="clearing.unassignedStations"
      badge={
        <SectionStatusBadge
          loading={loading}
          error={error}
          count={stations.length}
          singular="station"
          plural="stations"
        />
      }
    >
      {loading && (
        <div className="flex align-items-center gap-2">
          <ProgressSpinner
            style={{ width: "1.5rem", height: "1.5rem" }}
            strokeWidth="4"
          />
          <span className="text-color-secondary">
            Loading unassigned stations...
          </span>
        </div>
      )}

      {!loading && error && (
        <div className="flex align-items-center gap-2 text-red-500">
          <i className="pi pi-times-circle" />
          <span>Failed to load unassigned stations.</span>
        </div>
      )}

      {!loading && !error && stations.length === 0 && (
        <div className="flex align-items-center gap-2 text-green-600">
          <i className="pi pi-check-circle text-xl" />
          <span>All stations are assigned.</span>
        </div>
      )}

      {!loading && !error && stations.length > 0 && (
        <DataTable
          value={stationData}
          paginator
          rows={5}
          rowsPerPageOptions={[5, 10, 25]}
          rowHover
          emptyMessage="No unassigned stations found."
        >
          <Column
            field="id"
            header="Station ID"
            sortable
            style={{ ...columnStyle, width: "30%" }}
          />
          <Column
            body={assignBodyTemplate}
            header="Assign Customer"
            style={{ ...columnStyle, width: "70%" }}
          />
        </DataTable>
      )}
    </CollapsibleSection>
  );
};
